import { Alert, DatePicker } from "antd";
import { UserFormInterface } from '../definitions'
import dayjs from "dayjs";

interface objectInterface {
    [key: string]: string
}

interface DateInputInterface {
    errors: objectInterface,
    onChange: (date: dayjs.Dayjs | null, dateString: string) => void,
    name: string,
    placeholder: string,
    userForm: UserFormInterface,
    displayName?: string
}

function DateInputHolder({ errors, onChange, name, placeholder, userForm, displayName }: DateInputInterface) {
    if (displayName === undefined || displayName === "") {
        displayName = placeholder
    }

    const inputStyle: Object = {
        width: "100%"
    };

    let str = name as keyof typeof userForm;
    const dateValue = userForm[str] ? dayjs(userForm[str] as string) : null;

    return (
        <>
            {
                errors[name] !== undefined ?
                    <Alert banner showIcon message={errors[name]} type="error" />
                    :
                    null
            }
            <label>
                {displayName}
            </label>
            <div
                onKeyDown={(e) => {
                    // Store original value and cursor position before key press
                    const input = e.target as HTMLInputElement;
                    if (input && input.tagName === 'INPUT') {
                        (input as any)._prevValue = input.value;
                        (input as any)._prevLength = input.value.length;
                    }
                }}
                onKeyUp={(e) => {
                    // Auto-format date input as user types, but respect deletion
                    const input = e.target as HTMLInputElement;
                    if (input && input.tagName === 'INPUT') {
                        const currentValue = input.value;
                        const prevValue = (input as any)._prevValue || '';
                        const prevLength = (input as any)._prevLength || 0;
                        
                        // Don't format if user is deleting (value got shorter)
                        if (currentValue.length < prevLength) {
                            return;
                        }
                        
                        // Don't format if backspace or delete keys were pressed
                        if (e.key === 'Backspace' || e.key === 'Delete') {
                            return;
                        }
                        
                        let value = currentValue.replace(/\D/g, ''); // Remove non-digits
                        
                        // Format progressively: YYYY-MM-DD
                        if (value.length >= 4) {
                            value = value.substring(0, 4) + '-' + value.substring(4);
                        }
                        if (value.length >= 7) {
                            value = value.substring(0, 7) + '-' + value.substring(7, 9);
                        }
                        
                        // Limit to 10 characters (YYYY-MM-DD)
                        value = value.substring(0, 10);
                        
                        if (input.value !== value) {
                            input.value = value;
                            // Trigger input event to update the DatePicker
                            const event = new Event('input', { bubbles: true });
                            input.dispatchEvent(event);
                        }
                    }
                }}
            >
                <DatePicker 
                    onChange={onChange}
                    onBlur={(e) => {
                        // Handle manual typing by parsing the input value
                        const inputValue = (e.target as HTMLInputElement).value;
                        if (inputValue && inputValue !== userForm[str]) {
                            const parsedDate = dayjs(inputValue, "YYYY-MM-DD", true);
                            if (parsedDate.isValid()) {
                                onChange(parsedDate, inputValue);
                            }
                        }
                    }}
                    value={dateValue}
                    placeholder={placeholder}
                    style={inputStyle}
                    format="YYYY-MM-DD"
                    allowClear={false}
                />
            </div>
        </>
    );
}

export default DateInputHolder;